import { statsFields } from 'molecules/Stats/config';

import type { Input } from '@builder.io/sdk';

export const featuredTextFields = [
  {
    name: 'eyebrow',
    type: 'string',
  },
  {
    name: 'content',
    type: 'richText',
  },
  {
    name: 'featuredStats',
    type: 'list',
    subFields: statsFields,
  },
  {
    name: 'callToAction',
    type: 'object',
    subFields: [
      {
        name: 'text',
        type: 'string',
      },
      {
        name: 'link',
        type: 'string',
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

export const createFeaturedText = (showIf?: string): DeepReadonly<Input[]> => [
  {
    name: 'featuredText',
    type: 'object',
    subFields: featuredTextFields,
    showIf,
  },
];

export type FeaturedTextProps = GenerateBuilder<typeof featuredTextFields>;
